<script lang="ts">
	import ArrowLeft from '$lib/icons/arrowLeft.svelte';
	import type { SbImage, SbLink } from '../types';
	import Image from '../components/image.svelte';
	import Mill from '$lib/logos/mill.svelte';
	import { getSbUrl } from '$lib/utils/storyblok/url';
	import Button from '$lib/buttons/v3/button.svelte';
	import type { ISbStoryData } from '@storyblok/js';
	import { editable } from '../editable';

	interface Props {
		content: ISbStoryData<{
			custom_logo: SbImage;
			show_back_button: boolean;
			back_button_url: SbLink;
		}>['content'];
	}

	let { content }: Props = $props();
</script>

<header
	id="site-header"
	use:editable={content}
	class="fixed inset-x-0 top-0 z-50 flex items-center justify-center bg-white px-6 py-[13px] transition-transform md:px-8 lg:py-5 xl:px-12"
	style="transform: translate3d(0, var(--banner-height), 0)"
>
	{#if content.show_back_button}
		<div class="btn-back-container absolute left-0 md:left-4 lg:left-8">
			<Button
				class="btn-white btn-tertiary"
				href={content.back_button_url ? getSbUrl(content.back_button_url) : '/'}
				title="Go back"
			>
				<ArrowLeft />
			</Button>
		</div>
	{/if}
	{#if content.custom_logo.filename}
		<Image
			class="max-h-9 lg:max-h-12"
			src={content.custom_logo.filename}
			alt={content.custom_logo.alt}
			title={content.custom_logo.title}
			height={36}
			sizes={{ 1024: { height: 48 } }}
		/>
	{:else}
		<Mill class="h-[30px] w-[44.03px] text-green-3 lg:h-10 lg:w-[58.7px]" />
	{/if}
</header>

<style lang="scss">
	div.btn-back-container {
		--tertiary-bg-color: theme('colors.stone.5');
	}
</style>
